import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setPageSeo, setJsonLd } from '../utils/seo';
import './BlogPage.css';

const blogPosts = [
  {
    slug: 'photo-on-your-phone-vs-letter-in-a-drawer',
    title: "A Photo on Your Phone vs. a Letter in a Drawer \u2014 Which One Will Your Grandchildren Find?",
    excerpt: "We\u2019ve convinced ourselves that because we can store everything, we\u2019re preserving everything. But a photo of Christmas dinner isn\u2019t the same as your dad describing the Christmas he proposed to your mum.",
    date: '2026-05-12',
    image: 'https://images.unsplash.com/photo-1659397424953-77a12074e153?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxvbGQlMjBoYW5kd3JpdHRlbiUyMGxldHRlcnMlMjB3b29kZW4lMjBkcmF3ZXIlMjB2aW50YWdlJTIwa2VlcHNha2V8ZW58MHx8fHwxNzc4NzIwMTkyfDA&ixlib=rb-4.1.0&q=80&w=600',
  },
  {
    slug: 'mum-in-nursing-home-capture-her-stories',
    title: "Your Mum Is in a Nursing Home. She Still Has Stories. Here\u2019s How to Capture Them.",
    excerpt: "She had a whole life before you. Stories she\u2019s carried for seventy, eighty years \u2014 that have never been asked for and so have never been told. The window is shorter than you think.",
    date: '2026-05-12',
    image: 'https://images.unsplash.com/photo-1534768654272-e97681c3a2c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxlbGRlcmx5JTIwcGFyZW50JTIwbWVtb3J5JTIwZmFkaW5nJTIwb2xkJTIwcGhvdG9ncmFwaHMlMjBoYW5kc3xlbnwwfHx8fDE3Nzg3MjAxOTJ8MA&ixlib=rb-4.1.0&q=80&w=600',
  },
  {
    slug: 'before-dementia-takes-the-details',
    title: "Before Dementia Takes the Details: Why the Time to Capture Your Parent\u2019s Stories Is Right Now",
    excerpt: "Early to moderate dementia is often the last period when someone can tell their story coherently, with detail. One family wished they\u2019d started twelve months earlier.",
    date: '2026-05-12',
    image: 'https://images.unsplash.com/photo-1723140934387-aef910e0ea61?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxlbGRlcmx5JTIwcGFyZW50JTIwbWVtb3J5JTIwZmFkaW5nJTIwb2xkJTIwcGhvdG9ncmFwaHMlMjBoYW5kc3xlbnwwfHx8fDE3Nzg3MjAxOTJ8MA&ixlib=rb-4.1.0&q=80&w=600',
  },
  {
    slug: 'dad-doesnt-know-how-to-use-an-app',
    title: "Your Dad Doesn\u2019t Know How to Use an App. He Knows How to Use a Phone.",
    excerpt: "Every few years a new app promises to help families preserve stories. Then your 82-year-old father tries to use it. This is usually the thing that actually works.",
    date: '2026-05-12',
    image: 'https://images.unsplash.com/photo-1716558057044-72f92e6a5654?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxlbGRlcmx5JTIwbWFuJTIwY29uZnVzZWQlMjBzbWFydHBob25lJTIwdGVjaG5vbG9neSUyMGZydXN0cmF0ZWR8ZW58MHx8fHwxNzc4NzIwMTkyfDA&ixlib=rb-4.1.0&q=80&w=600',
  },
  {
    slug: 'dad-knew-how-to-use-a-phone',
    title: "Dad Doesn\u2019t Know How to Use an App",
    excerpt: "My father raised ten children on a dairy farm. He could fix anything with a piece of wire. But the digital world we live in now doesn\u2019t meet people halfway \u2014 and that\u2019s why Binding Thread was built around the simplest tool of all.",
    date: '2026-05-19',
    image: 'https://images.unsplash.com/photo-1495107334309-fcf20504a5ab?crop=entropy&cs=srgb&fm=jpg&w=600&q=80',
  },
  {
    slug: 'she-wants-her-kids-to-remember-her-voice',
    title: "She\u2019s Not Ready to Go. She Just Wants Her Kids to Remember Her Voice.",
    excerpt: "When a young Mum is diagnosed with a terminal illness, one of the most common things she lies awake thinking about is whether her children will really remember her.",
    date: '2026-05-12',
    image: 'https://images.unsplash.com/photo-1475609471617-0ef53b59cff5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxtb3RoZXIlMjBob2xkaW5nJTIwY2hpbGRyZW4lMjB3YXJtJTIwZW1vdGlvbmFsJTIwbG92ZSUyMHRlbmRlcnxlbnwwfHx8fDE3Nzg3MjAxOTJ8MA&ixlib=rb-4.1.0&q=80&w=600',
  }
];

function BlogPage() {
  useEffect(() => {
    setPageSeo({
      title: 'Blog | Preserving Family Stories & Memories | Binding Thread',
      description: 'Articles on preserving your loved one\u2019s stories as keepsake letters. Tips for capturing family memories from parents and grandparents \u2014 from $29/month, no technology needed.',
      canonical: 'https://www.bindingthread.com.au/blog',
      ogImage: 'https://www.bindingthread.com.au/logo-final.png'
    });
    setJsonLd('ld-blog', {
      "@context": "https://schema.org",
      "@type": "Blog",
      "name": "Binding Thread Blog",
      "description": "Articles on preserving family stories and memories as keepsake letters.",
      "url": "https://www.bindingthread.com.au/blog",
      "publisher": {
        "@type": "Organization",
        "name": "Binding Thread",
        "url": "https://www.bindingthread.com.au",
        "logo": "https://www.bindingthread.com.au/logo-final.png"
      }
    });
  }, []);

  return (
    <div className="blog-page" data-testid="blog-page">
      <section className="blog-hero">
        <div className="container">
          <h1>Blog</h1>
          <p className="blog-hero-sub">Binding Thread is a keepsake letter and memory preservation service that helps you capture your elderly parent&apos;s memories in a simple, meaningful way. From turning phone calls into letters to preserving stories from hospital or nursing home moments, this is a physical keepsake service designed to honour what matters most&mdash;no technology required.</p>
        </div>
      </section>

      <section className="blog-list">
        <div className="container">
          <div className="blog-grid">
            {[...blogPosts].sort((a, b) => new Date(b.date) - new Date(a.date)).map(post => (
              <Link to={`/blog/${post.slug}`} key={post.slug} className="blog-card" data-testid={`blog-card-${post.slug}`}>
                <div className="blog-card-image">
                  {post.image ? (
                    <img src={post.image} alt={post.title} />
                  ) : (
                    <div className="blog-card-placeholder"></div>
                  )}
                </div>
                <div className="blog-card-content">
                  <span className="blog-card-date">{new Date(post.date).toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
                  <h2>{post.title}</h2>
                  <p>{post.excerpt}</p>
                  <span className="blog-card-link">Read more &rarr;</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default BlogPage;
